/* 请求模块 */
import axios from 'axios'
import { getToken, removeToken, setToken } from '@/utils/auth'
import { Notify, Toast } from 'vant'
import store from '@/store'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const request = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  // 超时
  timeout: 60000,
  options: { loading: false, error: true, loadingText: '加载中' }
})

// 加载弹窗
function Loading (message) {
  Toast.loading({
    message,
    duration: 0,
    forbidClick: true
  })
}

// request拦截器
request.interceptors.request.use(
  async config => {
    // setToken(
    //   'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImViOWE0MTlhLWViM2EtNGYyYS1iNGU4LTQ3NDZjMWVmN2ZjOCJ9.blZ0xCFdVRGkK9qACglLFjV0-fAcvh2H4defJUrVbg7dsaEGV4YsWet6xnx1KYPsk45BhHXuYq71VIpPRmVWBg'
    // )

    if (getToken()) {
      config.headers.Authorization = getToken()
    }

    // if (getToken() && !isToken) {
    //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?'
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName]
        var part = encodeURIComponent(propName) + '='
        if (value !== null && typeof value !== 'undefined') {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              const params = propName + '[' + key + ']'
              var subPart = encodeURIComponent(params) + '='
              url += subPart + encodeURIComponent(value[key]) + '&'
            }
          } else {
            url += part + encodeURIComponent(value) + '&'
          }
        }
      }
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }
    config.options.loading && Loading(config.options.loadingText)
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  async response => {
    const res = response.data
    Toast.clear()
    if (res.code == 400 && getToken()) {
      Toast({ message: res.msg, duration: 10000 })
      return res
    } else if (res.code !== 200) {
      if (res.code === 401) {
        return await store.dispatch('user/GetCode')
      } else if (getToken() && res.msg) {
        Toast.fail(res.msg)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    Toast.clear()
    console.log('err' + error) // for debug
    const resp = error.response
    if (resp && resp.status == 400 && getToken() && resp.data.msg) {
      Notify({ type: 'danger', message: resp.data.msg, duration: 5 * 1000 })
    }
    return Promise.reject(error)
  }
)

export default request
